/** Licensed banks commonly operating in Saudi Arabia (display names, alphabetical). */
export const SAUDI_BANKS: string[] = [
  'Alinma Bank',
  'Arab National Bank (ANB)',
  'Bank Al Bilad',
  'Bank AlJazira',
  'Banque Saudi Fransi (BSF)',
  'Dubai Islamic Bank',
  'Emirates NBD',
  'Gulf International Bank Saudi Arabia (GIB)',
  'Kuwait Finance House (KFH)',
  'Riyad Bank',
  'Saudi Awwal Bank (SAB)',
  'Saudi National Bank (SNB)',
  'Saudi Investment Bank (SAIB)',
  'The Saudi British Bank (SABB)',
  'Al Rajhi Bank',
].sort((a, b) => a.localeCompare(b));
